import { Route, Switch, withRouter } from "react-router-dom";
import { compose, lifecycle, withHandlers } from "recompose";
import { pure, withState } from "recompose";

// import BankAccountForm from "../../components/BankAccount/BankAccountForm";
import BankAccountEdit from "../../components/BankAccount/BankAccountEdit";
import BankAccountForm from "../../components/BankAccount/BankAccountForm";
// import BudgeaHandler from "../../components/Payment/BudgeaHandler/BudgeaHandler";
import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import PaymentAffectation from "../../components/Payment/PaymentAffectation/PaymentAffectation";
import PaymentForm from "../../components/Payment/PaymentForm/PaymentForm";
import PaymentListContainer from "../../components/Payment/PaymentList/PaymentListContainer";
import Queries from "../../queries/queries2";
import React from "react";
import { Redirect } from "react-router-dom";
import Spinner from "../../elements/Spinner/Spinner";
import _ from "lodash-es";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import moment from "moment";

const BANK_ACCOUNT_CREATED_SUBSCRIPTION = gql`
  subscription onBankAccountCreated($companyId: ID!) {
    bankAccountCreated(companyId: $companyId) {
      id
      solde
      currency {
        id
      }
      dateCloture
      active
      syncAccount
      name
      originalName
    }
  }
`;

const companyInfoForContainer = graphql(Queries.getCompanyInfoForContainer, {
  name: "getCompanyInfoForContainer"
});

const getAllBankAccountsQuery = graphql(Queries.GET_ALL_BANK_ACCOUNTS, {
  name: "getAllBankAccountsQuery",
  options: { fetchPolicy: "network-only" }
});

const updateBankTransactionMutation = graphql(
  Queries.UPDATE_BANK_TRANSACTION_MUTATION,
  { name: "updateBankTransactionMutation" }
);

const confirmBankTransactionMutation = graphql(
  Queries.CONFIRM_BANK_TRANSACTION_MUTATION,
  { name: "confirmBankTransactionMutation" }
);

const validateAllBankTransactionsMutation = graphql(
  Queries.VALIDATE_ALL_BANK_TRANSACTIONS_MUTATION,
  { name: "validateAllBankTransactionsMutation" }
);

const connectAttachmentToBankTransaction = graphql(
  Queries.connectAttachmentToBankTransaction,
  { name: "connectAttachmentToBankTransaction" }
);

const deleteBankTransactionMutation = graphql(
  Queries.DELETE_BANK_TRANSACTION_MUTATION,
  { name: "deleteBankTransactionMutation" }
);

const reQualifyBankTransactionMutation = graphql(
  Queries.REQUALIFY_BANK_TRANSACTION_MUTATION,
  { name: "reQualifyBankTransactionMutation" }
);

const deleteBankTransactionAttachmentMutation = graphql(
  Queries.deleteBankTransactionAttachment,
  { name: "deleteBankTransactionAttachmentMutation" }
);

const redirectState = withState("redirect", "setRedirect", false);

const notifications = withHandlers({
  sendSuccessUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_paymentHasBeenQualified" />;
    sendNotification(notif);
  },

  sendFailureUpdateNotification: ({ sendNotification, intl }) => (msg = "") => {
    let notif = NotificationProvider.getFailureNotification();
    console.log("sendFailureUpdateNotification");

    if (true || msg === "") {
      notif.message = (
        <FormattedMessage id="ids_errorPaymentCouldNotBeQualified" />
      );
    } else {
      notif.message = msg || msg.name;
    }

    sendNotification(notif);
  },

  sendSuccessDeleteNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_paymentHasBeenDeleted" />;
    sendNotification(notif);
  },

  sendFailureDeleteNotification: ({ sendNotification, intl }) => (msg = "") => {
    let notif = NotificationProvider.getFailureNotification();
    console.log("sendFailureDeleteNotification");

    if (true || msg === "") {
      notif.message = (
        <FormattedMessage id="ids_errorPaymentCouldNotBeDeleted" />
      );
    } else {
      notif.message = msg || msg.name;
    }

    sendNotification(notif);
  },

  sendFailureNotification: ({ sendNotification, intl }) => (msg = "") => {
    let notif = NotificationProvider.getFailureNotification();
    console.log("sendFailureNotification");

    switch (msg.name) {
      case "BadAccess":
        notif.message = <FormattedMessage id="ids_badAccess" />;
        break;
      case "NoPermission":
        notif.message = <FormattedMessage id="ids_NoPermission" />;
        break;
      case "AuthRequired":
        notif.message = <FormattedMessage id="ids_AuthRequired" />;
        break;
      case "AuthFailed":
        notif.message = <FormattedMessage id="ids_AuthFailed" />;
        break;
      case "StateInvalid":
        notif.message = <FormattedMessage id="ids_StateInvalid" />;
        break;
      case "RequireParamsAsArray":
        notif.message = <FormattedMessage id="ids_RequireParamsAsArray" />;
        break;

      default:
        notif.message = msg || msg.name;
    }

    sendNotification(notif);
  }
});

const handlers = withHandlers({
  updateBankTransaction: ({
    sendSuccessUpdateNotification,
    sendFailureUpdateNotification,
    updateBankTransactionMutation,
    connectAttachmentToBankTransaction,
    companyId,
    withRouter,
    history,
    match
  }) => async (bankTransaction, fullUpdate) => {
    //id, status) => {
    console.log("174 - updateBankTransaction", bankTransaction, fullUpdate);
    const bankAccount = sessionStorage.getItem(
      "paymentListState_bankAccountSelected"
    );

    console.log("id, status", bankTransaction.id, bankTransaction.status);
    // console.log("bankAccount", bankAccount);
    const bankAccountId = (bankAccount && JSON.parse(bankAccount).id) || "";
    // console.log("bankAccountId", bankAccountId);

    try {
      await updateBankTransactionMutation({
        variables: {
          id: bankTransaction.id,
          status: bankTransaction.status,
          attachmentId:
            bankTransaction.attachment && bankTransaction.attachment.id,
          connectAttachment: !!bankTransaction.attachment,
          date: bankTransaction.date,
          fullUpdate: fullUpdate === undefined ? true : fullUpdate
        },
        refetchQueries: [
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: { status: "AQUALIFIER" }
            }
          },
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: {}
            }
          },
          {
            query: Queries.GET_BANK_TRANSACTIONS_COUNT,
            variables: {
              bankAccountId
            }
          },
          {
            query: Queries.getDashboardInfos,
            variables: {
              companyId: companyId
            }
          },
          {
            query: Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
            variables: {
              bankAccountId: bankAccountId
            }
          }
        ]
      });
      sendSuccessUpdateNotification();
      // if (match.path !== "/payments") {
      // history.push("/payments");
      // history.goBack();
      // }
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  }
});

const confirmHandlers = withHandlers({
  confirmBankTransaction: ({
    sendSuccessUpdateNotification,
    sendFailureUpdateNotification,
    confirmBankTransactionMutation,
    companyId,
    withRouter,
    history,
    match
  }) => async bankTransaction => {
    //id, status) => {
    console.log("confirmBankTransaction", bankTransaction);
    const bankAccount = sessionStorage.getItem(
      "paymentListState_bankAccountSelected"
    );

    console.log("id", bankTransaction.id);
    const bankAccountId = (bankAccount && JSON.parse(bankAccount).id) || "";

    try {
      await confirmBankTransactionMutation({
        variables: {
          id: bankTransaction.id
        },
        refetchQueries: [
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: { status: "AQUALIFIER" }
            }
          },
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: {}
            }
          },
          {
            query: Queries.GET_BANK_TRANSACTIONS_COUNT,
            variables: {
              bankAccountId
            }
          },
          {
            query: Queries.getDashboardInfos,
            variables: {
              companyId: companyId
            }
          },
          {
            query: Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
            variables: {
              bankAccountId: bankAccountId
            }
          }
        ]
      });
      sendSuccessUpdateNotification();
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  },

  validateAllBankTransactions: ({
    sendSuccessUpdateNotification,
    sendFailureUpdateNotification,
    validateAllBankTransactionsMutation,
    companyId,
    withRouter,
    history,
    match
  }) => async bankAccountId => {
    //id, status) => {

    console.log("validateAllBankTransactions", bankAccountId);

    // const bankAccount =
    //   sessionStorage.getItem(
    //   "paymentListState_bankAccountSelected"
    // );

    try {
      await validateAllBankTransactionsMutation({
        variables: {
          id: bankAccountId
        },
        refetchQueries: [
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: { status: "AQUALIFIER" }
            }
          },
          {
            query: Queries.GET_ALL_BANK_TRANSACTIONS,
            variables: {
              companyId,
              bankAccountId,
              filter: {}
            }
          },
          {
            query: Queries.GET_BANK_TRANSACTIONS_COUNT,
            variables: {
              bankAccountId
            }
          },
          {
            query: Queries.getDashboardInfos,
            variables: {
              companyId: companyId
            }
          },
          {
            query: Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
            variables: {
              bankAccountId: bankAccountId
            }
          }
        ]
      });
      sendSuccessUpdateNotification();
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  }
});

const deleteHandlers = withHandlers({
  deleteBankTransaction: ({
    sendSuccessDeleteNotification,
    sendFailureDeleteNotification,
    deleteBankTransactionMutation,
    companyId,
    withRouter,
    history,
    match
  }) => async bankTransactionId => {
    //id, status) => {
    console.log("deleteBankTransaction(", bankTransactionId, ")");
    // const bankAccount = sessionStorage.getItem(
    //   "paymentListState_bankAccountSelected"
    // );

    console.log("id", bankTransactionId);
    // console.log("bankAccount", bankAccount);
    // const bankAccountId = (bankAccount && JSON.parse(bankAccount).id) || "";
    // console.log("bankAccountId", bankAccountId);

    try {
      await deleteBankTransactionMutation({
        variables: { id: bankTransactionId }
        // refetchQueries: [
        //   {
        //     query: Queries.GET_ALL_BANK_TRANSACTIONS,
        //     variables: {
        //       bankAccountId,
        //       filter: { status: "AQUALIFIER" }
        //     }
        //   },
        //   {
        //     query: Queries.GET_ALL_BANK_TRANSACTIONS,
        //     variables: {
        //       bankAccountId,
        //       filter: {}
        //     }
        //   },
        //   {
        //     query: Queries.GET_BANK_TRANSACTIONS_COUNT,
        //     variables: {
        //       bankAccountId
        //     }
        //   },
        //   {
        //     query: Queries.getDashboardInfos,
        //     variables: {
        //       companyId: companyId
        //     }
        //   },
        //   {
        //     query: Queries.GET_LEDGER_CONNECTION,
        //     variables: {
        //       companyId: companyId
        //     }
        //   },
        //   {
        //     query: Queries.GET_ALL_INVOICES,
        //     variables: {
        //       companyId: companyId,
        //       first: 20,
        //       skip: 0,
        //       filterCount: { company: { id: companyId } }
        //     }
        //   }
        // ]
      });
      sendSuccessDeleteNotification();
      // if (match.path !== "/payments") {
      //history.push("/payments");
      history.goBack();
      // }
    } catch (e) {
      console.log(e);
      sendFailureDeleteNotification();
    }
  }
});

const reQualifyHandlers = withHandlers({
  reQualifyBankTransaction: ({
    reQualifyBankTransactionMutation,
    companyId,
    withRouter,
    history,
    match
  }) => async bankTransactionId => {
    console.log("reQualifyBankTransaction:", bankTransactionId);

    try {
      reQualifyBankTransactionMutation({
        variables: { id: bankTransactionId }
      });
      history.goBack();
      // }
    } catch (e) {
      console.log(e);
    }
  }
});

const createBankAccountHandlers = withHandlers({
  createBankAccount: ({
    companyId,
    withRouter,
    history,
    createBankAndProviderAccountMutation,
    match
  }) => async values => {
    console.log("createBankAccount:", values);

    values["companyId"] = companyId;
    values["bic"] = "";
    values["number"] = "";
    values["currency"] = values.currencyId;

    switch (values.importFormat) {
      case "IMPORT_BANKOFAMERICA":
        values["provider"] = "IMPORT_BANKOFAMERICA";
        break;

      case "IMPORT_BASIC_DDMMYYYY":
        values["provider"] = "IMPORT_BASIC_DDMMYYYY";
        break;

      case "IMPORT_BASIC_MMDDYYYY":
        values["provider"] = "IMPORT_BASIC_MMDDYYYY";
        break;

      default:
        values["provider"] = null;
        break;
    }

    values["accountId"] = "fake_" + (new Date().getTime()).toString();

    console.log("VALUES BEFORE CLIENT CREATE", values);
    try {
      const mutation = await createBankAndProviderAccountMutation({
        variables: values
      });

      // sendSuccessCreateNotification();
      return mutation;
    } catch (e) {
      console.log(e);
      // sendFailureCreateNotification();
    }
  }
});

const componentLifecycle = lifecycle({
  componentDidMount() {
    if (!this.props.getAllBankAccountsQuery) return;

    // BankAccountCreated
    this.unsubscribeBankAccountCreated = this.props.getAllBankAccountsQuery.subscribeToMore(
      {
        document: BANK_ACCOUNT_CREATED_SUBSCRIPTION,
        variables: {
          companyId: this.props.companyId
        },

        updateQuery: (prev, { subscriptionData }) => {
          // console.log("151 - prev=",prev, "subscriptionData=", subscriptionData);
          this.props.getAllBankAccountsQuery.refetch();
          return prev;
        }
      }
    );
    return;
  },

  componentWillUnmount() {
    this.unsubscribeBankAccountCreated();
  }
});

const PaymentsContainerPure = ({
  companyId,
  getAllBankAccountsQuery,
  updateBankTransaction,
  confirmBankTransaction,
  validateAllBankTransactions,
  deleteBankTransaction,
  deleteBankTransactionAttachmentMutation,
  reQualifyBankTransaction,
  path,
  name,
  sendSuccessUpdateNotification,
  sendFailureUpdateNotification,
  sendFailureNotification,
  getCompanyInfoForContainer,
  history,
  redirect,
  sendNotification,
  setRedirect,
  createBankAccount,
  defaultCurrencyUSD,
  intl,
  handleMinimizeSidebar
}) => {
  // console.log("PaymentsContainerPure", getAllBankAccountsQuery);

  if (getAllBankAccountsQuery.loading || defaultCurrencyUSD.loading) {
    return <Spinner size="lg" fullScreen />;
  }

  const locale = `${intl.locale.split("-")[0]}`;
  if (locale !== "en") {
    // en is enabled by default already
    import(`moment/locale/${locale}`).then(() => {
      moment.locale(locale);
    });
  }

  let bankAccounts =
    (getAllBankAccountsQuery.companyAllBankAccounts &&
      getAllBankAccountsQuery.companyAllBankAccounts.bankAccounts) ||
    [];
  let providerAccounts =
    (getAllBankAccountsQuery.companyAllBankAccounts &&
      getAllBankAccountsQuery.companyAllBankAccounts.providerAccounts) ||
    [];

  bankAccounts = _.orderBy(
    bankAccounts,
    [
      ba => {
        return ba.countToQualify > 0;
      },
      ba => {
        const d = ba.countToQualify || "0";
        return d;
      },
      ba => {
        return ba.countToValidate > 0;
      },
      ba => {
        const d = ba.countToValidate || "0";
        return d;
      },
      ba => {
        const d =
          (!!ba.bankTransactions &&
            ba.bankTransactions[0] &&
            ba.bankTransactions[0].date) ||
          "0";
        return d;
      }
    ],
    ["desc", "desc", "desc", "desc", "desc"]
  );

  // console.log("bankAccounts2", bankAccounts);

  const biConnection =
    getAllBankAccountsQuery.companyAllBankAccounts &&
    getAllBankAccountsQuery.companyAllBankAccounts.biConnexion;

  const BiUserId = biConnection ? biConnection.userId : undefined;

  const BiAccessToken = biConnection ? biConnection.accessToken : undefined;
  // console.log("BiUserId", BiUserId);
  // console.log("BiAccessToken", BiAccessToken);
  // console.log("getAllBankAccountsQuery", getAllBankAccountsQuery.company);

  if (redirect) {
    return <Redirect to="/" push={true} />;
  }
  return (
    <Switch>
      <Route
        exact
        path="/payments"
        component={() => (
          <PaymentListContainer
            companyDefaultInfos={getCompanyInfoForContainer}
            updateBankTransaction={updateBankTransaction}
            confirmBankTransaction={confirmBankTransaction}
            validateAllBankTransactions={validateAllBankTransactions}
            bankAccounts={bankAccounts}
            providerAccounts={providerAccounts}
            companyId={companyId}
            BiUserId={BiUserId}
            BiAccessToken={BiAccessToken}
            name={name}
            path={path}
            redirectToBudgea={() => {
              setRedirect(true);
            }}
            sendSuccessUpdateNotification={sendSuccessUpdateNotification}
            sendFailureNotification={sendFailureNotification}
            locale={locale}
            handleMinimizeSidebar={handleMinimizeSidebar}
          />
        )}
      />

      <Route
        path="/payments/:id/affectation"
        component={routeProps => (
          <PaymentAffectation
            companyDefaultInfos={getCompanyInfoForContainer}
            companyId={companyId}
            id={routeProps.match.params.id}
            sendNotification={sendNotification}
            sendSuccessUpdateNotification={sendSuccessUpdateNotification}
            sendFailureUpdateNotification={sendFailureUpdateNotification}
            deleteBankTransactionAttachmentMutation={
              deleteBankTransactionAttachmentMutation
            }
            updateBankTransaction={(e1, e2) => {
              updateBankTransaction(e1, e2);
              history.goBack();
            }}
            deleteBankTransaction={deleteBankTransaction}
            reQualifyBankTransaction={reQualifyBankTransaction}
            handleMinimizeSidebar={handleMinimizeSidebar}
            history={history}
          />
        )}
      />
      <Route path="/payments/new" component={() => <PaymentForm />} />

      <Route
        path="/payments/bank_accounts/new"
        component={routeProps => (
          <BankAccountForm
            companyId={companyId}
            // bankAccountFromQuery={newBankAccount}
            onSave={values => {
              console.log("VALUES=", values);
              try {
                createBankAccount(values);
                history.goBack();
              } catch (e) {
                console.log("error", e);
              }
            }}
            defaultCurrencyUSD={defaultCurrencyUSD}
            handleMinimizeSidebar={handleMinimizeSidebar}
          // updateFormValue={updateFormValue}
          // sendNotification={sendNotification}
          />
        )}
      />
      <Route
        path="/payments/bank_accounts/:id/edit"
        component={routeProps => (
          <BankAccountEdit
            companyId={companyId}
            id={routeProps.match.params.id}
            sendNotification={sendNotification}
            handleMinimizeSidebar={handleMinimizeSidebar}
          />
        )}
      />
    </Switch>
  );
};

export default compose(
  graphql(Queries.CREATE_BANK_AND_PROVIDER_MUTATION, {
    name: "createBankAndProviderAccountMutation"
  }),
  graphql(Queries.GetCurrencyByCode, {
    options: { variables: { code: "USD" } },
    name: "defaultCurrencyUSD"
  }),
  redirectState,
  withRouter,
  companyInfoForContainer,
  getAllBankAccountsQuery,
  componentLifecycle,
  updateBankTransactionMutation,
  confirmBankTransactionMutation,
  validateAllBankTransactionsMutation,
  deleteBankTransactionMutation,
  deleteBankTransactionAttachmentMutation,
  reQualifyBankTransactionMutation,
  connectAttachmentToBankTransaction,
  notifications,
  handlers,
  confirmHandlers,
  deleteHandlers,
  reQualifyHandlers,
  createBankAccountHandlers,
  pure
)(injectIntl(withRouter(PaymentsContainerPure)));
